<template>
  <div>
    <h1>Tarifas planas</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar tarifa plana"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-table
        show-empty
        stacked="md"
        :items="getAllFIxedFares"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        emptyFilteredText="No existen registros por mostrar"
        empty-text="No existen registros por mostrar">
        <template v-slot:cell(acciones)="row">
          <router-link size="sm" :to="{name:'updateFixedFares', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
          <b-button class="btn-sm" variant="outline-danger"  @click="showDeleteFareModal(row.item)">Eliminar</b-button>
        </template>
        <template v-slot:cell(freeRoadFare)="row">
          {{ '$'+row.item.freeRoadFare }}
        </template>
        <template v-slot:cell(preferential)="row">
      <template v-if="row.item.preferential == undefined">
      </template>
      <template v-else>
        <div :class="statusDictionary[row.item.preferential].class">{{ statusDictionary[row.item.preferential].label }}</div>
      </template>
    </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllFIxedFares.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const GET_ALL_FIX_FARES = gql`
  query getAllFIxedFares{
    getAllFIxedFares{
      id
      name
      freeRoadFare
      kmTotal
      createdBy
      rushHour
      preferential
      source {
        id
        name
      }
      destination{
        id
        name
      }
    }
  }
`
const DELETE_FIXED_FARE = gql`
mutation deletefixedFare($fixedFareId: Int){
  deletefixedFare(fixedFareId: $fixedFareId){
    success
    message
  }
}
`
export default {
  data() {
    return {
      fields: [
        // { key: 'id', label: 'ID' },
        { key: 'name', label: 'Nombre de la tarifa' },
        { key: 'freeRoadFare', label: 'Costo de vialidad' },
        // { key: 'tollwayFare', label: 'Costo de vialidad caseta' },
        { key: 'kmTotal', label: 'Kilómetros de ida' },
        { key: 'source.name', label: 'Origen' },
        { key: 'destination.name', label: 'Destino' },
        { key: 'createdBy', label: 'Responsable' },
        { key: 'preferential', label: 'Preferente' },
        'acciones',
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getAllFIxedFares: [],
      statusDictionary: {
        0: { label: '', class: 'text-black font-weight-bold' },
        1: { label: '✔', class: 'text-success font-weight-bold' },
      },
    }
  },
  apollo: {
    getAllFIxedFares: {
      query: GET_ALL_FIX_FARES,
      result({ data }) {
        this.totalRows = data.getAllFIxedFares.length
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    deleteFare(fare) {
      this.$apollo.mutate({
        mutation: DELETE_FIXED_FARE,
        variables: {
          fixedFareId: parseInt(fare.id),
        },
        context: headers(),
      })
        .then(data => {
          console.log(data)
          this.$apollo.queries.getAllFIxedFares.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteFareModal(fare) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas eliminar la tarifa ${fare.name}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.deleteFare(fare)
        },
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
